import axios from 'axios'
import constants from '../constants'
import store from 'store'
import { api, apiURL } from './_init'
import { getAuthorizationHeader } from './_token'

export const fetchLibraryImages = async (body) => {
  const { page = 1, limit = 15, search = null, sort_by, sort_order, ratio, image_type = null } = body

  try { 
    const response = await api.post('/gallery', {
      page,
      limit,
      search,
      sort_by: sort_by ? sort_by : undefined,
      sort_order: sort_order ? sort_order : undefined,
      ratio: ratio ? ratio : undefined,
      image_type,
    })
  
    if (response.status !== 200) {
      throw new Error()
    }
  
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const updateLibraryImage = async (body) => {
  const { image_id, image_name, group_id } = body

  try { 
    const response = await api.put('/gallery/images', {
      id: image_id,
      new_image_name: image_name,
      group_id,
    })
  
    if (response.status !== 200) {
      throw new Error()
    }
  
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const deleteLibraryImages = async (payload) => {
  const params = JSON.stringify(payload)

  try {
    const response = await api.delete(`/gallery/images?payload=${params}`)

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const uploadLibraryImages = async (files, configData = {}) => {
  const partnerId = store.getState()?.user?.partnerId
  const bodyFormData = new FormData()

  files.forEach((entry) => {
    const file = entry?.file ?? entry
    const ratio = entry?.ratio

    bodyFormData.append('image', file)

    if (ratio) {
      bodyFormData.append('ratio', ratio)
    }
  })

  try {
    const response = await axios({
      method: 'post',
      url: `${apiURL}${constants.API_VERSION}/gallery/images`,
      data: bodyFormData,
      cancelToken: configData.cancelToken,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getAuthorizationHeader(),
        'X-Preferred-Partner-Id': partnerId,
      },
    })

    if (response.status !== 201) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      return {
        success: false,
        cancelled: true,
        error: error.message,
      }
    }

    return {
      success: false,
      error: error.message,
    }
  }
}

export const downloadLibraryImage = async ({ id, group_id }) => {
  const partnerId = store.getState()?.user?.partnerId

  try {
    const response = await axios({
      method: 'get',
      url: `${apiURL}${constants.API_VERSION}/gallery/images/download`,
      params: { id, group_id },
      headers: {
        Authorization: getAuthorizationHeader(),
        'X-Preferred-Partner-Id': partnerId,
      },
      responseType: 'blob',
    })

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    }
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    }
  }
}

export const fetchLibraryGroup = async (body) => {
  const { image_id, group_id } = body

  try { 
    const response = await api.get('/gallery/images', {
      params: {
        id: image_id,
        group_id,
      },
    })
  
    if (response.status !== 200) {
      throw new Error()
    }
  
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const fetchLibraryCounts = async () => {
  try {
    const response = await api.get('/gallery/count')

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const saveLibraryImages = async (image) => {
  try {
    const response = await api.post('/gallery/upload_image', {media: image})
  
    if (response.status !== 200) {
      throw new Error()
    }
  
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}